//All the available sensors
const wiredSensorTypes = [
    {
        name: "DOL 16",
        type: "DOL16"
    },
    {
        name: "DOL 51",
        type: "DOL51"
    },
    {
        name: "DOL 53",
        type: "DOL53"
    },
    {
        name: "DOL 139",
        type: "DOL139"
    }
]

export default wiredSensorTypes;